<ng-container *appIfHasPrivileges="requiredPrivileges">
  <a mat-menu-item (click)="toggleExpansion()">
    <div class="flex flex-row">
      <div class="flex-1">{{ title }}</div>
      <div class="flex-1"></div>
      <div class="flex-initial">
        @if (!expanded) {
          <mat-icon>keyboard_arrow_down</mat-icon>
        }
        @if (expanded) {
          <mat-icon>keyboard_arrow_up</mat-icon>
        }
      </div>
    </div>
  </a>
  <mat-divider></mat-divider>
  @if (expanded) {
    <div class="sub-menu-container">
      <ng-content></ng-content>
    </div>
  }
</ng-container>
